module.exports = __webpack_public_path__ + "img/focus_2.f4b3e7f4.png";